import { useEffect, useState } from 'react';
import api from '../api/user/UserUserReq';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthProvider';
import { useLocation } from 'react-router-dom';


const useAuthCheck = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const { login, logout} = useAuth();
  
  const checkAuthStatus = async () => {
    try {
      const response = await api.get('user-me', { withCredentials: true });
      if (response.data.success) {
        login();
      } else {
        toast.error("Session was ended! You are not logged in!")
        logout();
      }
    } catch (error) {
      console.error('Not authorized');
      logout();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuthStatus();
  }, [location.pathname]);
  
  return { loading };
};

export default useAuthCheck;
